import { serviceMessageSetsFailure, serviceMessageSetsReload, serviceMessageSetsRequest, serviceMessageSetsSuccess } from 'actions/serviceMessageSetActions';
import { callApi } from 'apiClient';
import { OrgId, ServiceMessageSet } from 'shared/models';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'reducers';
import { toError } from 'shared/util/toError';

export type Options = {
    forceReload?: boolean;
};

export function useServiceMessageSets(orgId: OrgId | null, options: Options = {}) {
    const {
        forceReload = false,
    } = options;

    const { data, errorKey, loading, nextFetch } = useSelector((state: State) => state.serviceMessageSets);
    const dispatch = useDispatch();
    
    //
    // Load service message sets
    //
    useEffect(() => {
        if ((nextFetch || 0) < Date.now()) {
            dispatch(serviceMessageSetsRequest());
            void (async () => {
                try {
                    const result: ServiceMessageSet[] = await callApi('GET', '/api/service-message-sets');
                    dispatch(serviceMessageSetsSuccess(result));
                }
                catch (e) {
                    const err = toError(e);
                    dispatch(serviceMessageSetsFailure(err));
                }
            })();
        }
    }, [ orgId, loading, errorKey, nextFetch, dispatch ]);

    useEffect(() => {
        if (forceReload && orgId) {
            dispatch(serviceMessageSetsReload());
        }
    }, [ dispatch, forceReload, orgId ]);

    return {
        serviceMessageSets: data,
        loading,
        errorKey,
    };
}
